var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.4,425.4c22.5-3.6,25.7,28.3,6.5,31.5-22.5,3.6-25.7-28.3-6.5-31.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M318.6,193.7c22.9-22.5,19.1-61.2-6.9-79.4-32.9-23.1-117-20.1-130.2,26.9-3,10.6,0,19.1-7.8,28.2-16,18.8-45.7,6.5-45.7-18,0-34.8,23.5-67.5,52.6-84.4,42.6-24.8,116.7-23.5,158.1,3.6,64.6,42.2,60.9,138.4-6,176.1-6.3,3.5-13.4,5.4-19.5,9.3-20.8,13.4-28.9,41.5-31.3,64.8-1.1,10.9,2.7,19.4-6,28.8-14,15.2-42.2,7.8-44.4-13.2-5-45.9,17.1-101.2,57.3-125.3,9.9-5.9,21.6-9.2,30-17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.5,409.4c36-6.1,41.4,48,8,51.2s-38-46.1-8-51.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.244d61854e9f2e0c8d8cdc22301df824.svg";
export { ForwardRef as ReactComponent };